import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const SYMBOLS_URL = getBaseUrl('/symbols/');

export async function getSymbols(onlyFavorites = false) {
    const url = onlyFavorites ? `${SYMBOLS_URL}?onlyFavorites=${onlyFavorites}` : SYMBOLS_URL;
    return await appRequest.doGetRequest(url);
}

export async function searchSymbols(search, onlyFavorites, page) {
    const pageSize = 20;
    return await appRequest.doGetRequest(`${SYMBOLS_URL}?search=${search}&onlyFavorites=${onlyFavorites}&page=${page}&pageSize=${pageSize}`);
}

export async function getSymbol(symbol) {
    return await appRequest.doGetRequest(`${SYMBOLS_URL}${symbol}`);
}

export async function updateSymbol(symbol) {
    return await appRequest.doPatchRequest(`${SYMBOLS_URL}${symbol.symbol}`, symbol);
}

export async function syncSymbols() {
    return await appRequest.doPostRequest(`${SYMBOLS_URL}sync`, {});
}

// Disponibilidade de símbolos na TESTNET (dropdown ciente da testnet, 14/07). Memo de módulo:
// 1 fetch por sessão de página (componentes múltiplos — SelectSymbol, modal de template — não
// repetem a chamada). Erro NÃO fixa cache ruim: reseta pra permitir nova tentativa depois.
let _testnetAvailabilityPromise = null;
export async function getTestnetAvailability() {
    if (!_testnetAvailabilityPromise) {
        _testnetAvailabilityPromise = appRequest.doGetRequest(`${SYMBOLS_URL}testnet-availability`)
            .catch(err => { _testnetAvailabilityPromise = null; throw err; });
    }
    return _testnetAvailabilityPromise;
}